import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class WorkflowServices {
  /**
   *
   * @param {*} tenantId
   * @return
   */
  getPurchaseWorkflows = async (tenantId) => {
    const purchaseWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=PURCHASE_ORDER${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return purchaseWorkflows;
  }

  /**
   *
   * @param {*} tenantId
   * @return
   */
  getVendorWorkflows = async (tenantId) => {
    const getVendorWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=VENDOR_PAYOUT${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getVendorWorkflows;
  }

  getSalesEstimateWorkflows = async (tenantId) => {
    const getSalesEstimateWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=SALES_ESTIMATE${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getSalesEstimateWorkflows;
  }


  getSalesOrderWorkflows = async (tenantId) => {
    const getSalesOrderWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=SALES_ORDER${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getSalesOrderWorkflows;
  }


  getPackingSlipWorkflows = async (tenantId) => {
    const getPackingSlipWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=PACKING_SLIP${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getPackingSlipWorkflows;
  }

  
  /**
   *
   * @param {*} tenantId
   * @return
   */
  getInvoiceWorkflows = async (tenantId) => {
    const getInvoiceWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=INVOICE${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getInvoiceWorkflows;
  }

  /**
   *
   * @param {*} tenantId
   * @return
   */
  getCreditNoteWorkflows = async (tenantId) => {
    const getCreditNoteWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=CREDIT_NOTE${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getCreditNoteWorkflows;
  }

  /**
   *
   * @param {*} tenantId
   * @return
   */
  getDebitNoteWorkflows = async (tenantId) => {
    const getDebitNoteWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=DEBIT_NOTE${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getDebitNoteWorkflows;
  }

  /**
   *
   * @param {*} tenantId
   * @return
   */
  getPurchaseRequestWorkflows = async (tenantId) => {
    const getPurchaseRequestWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=PURCHASE_REQUISITION${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getPurchaseRequestWorkflows;
  }

  /**
 *
 * @param {*} tenantId
 * @return
 */
  getStockAdjustmentWorkflows = async (tenantId) => {
    const getStockAdjustmentWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=STOCK_ADJUSTMENT${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getStockAdjustmentWorkflows;
  }

  /**
*
* @param {*} tenantId
* @return
*/
  getStockTransferWorkflows = async (tenantId) => {
    const getStockTransferWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=STOCK_TRANSFER${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getStockTransferWorkflows;
  }

  getGoodsReceivingWorkflows = async (tenantId) => {
    const getGoodsReceivingWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=GOOD_RECEIVING_NOTE${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getGoodsReceivingWorkflows;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createWorkflows = async (payload) => {
    const formData = new FormData();
    formData.append('sheet', payload.file);
    formData.append('workflow_type', payload.workflowType);
    formData.append('tenant_department_id', payload.tenant_department_id);
    const createWorkflows = await Helpers.filePut({
      url: Constants.CREATE_WORKFLOWS,
      file: formData,
    });
    return createWorkflows;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  createWorkflowV2 = async (payload) => {
    const createWorkflows = await Helpers.put({
      url: Constants.WORKFLOWS,
      data: payload,
    });
    return createWorkflows;
  }

  /**
   * @param {*} tenantId
   * @param sampleType
   * @return
   */
  getPurchaseWorkflowSample = async (tenantId, sampleType) => {
    const getPurchaseWorkflowSample = await Helpers.getFile({
      url: `${`${Constants.GET_PURCHASE_WORKFLOW_SAMPLE}?tenant_id=${tenantId}`}${sampleType ? `&workflow_type=${sampleType}` : ''}`,
    });
    return getPurchaseWorkflowSample;
  }

  getDeliveryChallanWorkflows = async (tenantId) => {
    const getDeliveryChallanWorkflows = await Helpers.get({
      url: `${Constants.WORKFLOWS}?workflow_type=DELIVERY_CHALLAN${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return getDeliveryChallanWorkflows;
  }

  // add additional workflow approvals
  addAdditionalWorkflowApprovals = async (payload) => {
    const addAdditionalWorkflowApprovals = await Helpers.put({
      url: `${`${Constants.WORKFLOWS}/update-workflow`}`,
      data: payload,
    });
    return addAdditionalWorkflowApprovals;
  }
}
export default new WorkflowServices();
